import { createTheme, responsiveFontSizes, ThemeProvider, useTheme } from "@mui/material/styles";
import { TypographyOptions } from "@mui/material/styles/createTypography";
import React, { PropsWithChildren, useMemo } from "react";

const buildMaiteTypography = (base: any): TypographyOptions => ({
  ...base,
  fontFamily: ["Montserrat", "Roboto", "sans-serif"].join(","),
  h1: {
    ...base.h1,
    fontFamily: "Montserrat",
    fontSize: "32px",
    lineHeight: 30 / 24,
    fontWeight: 600,
  },
  h2: {
    ...base.h2,
    fontFamily: "Montserrat",
    fontSize: "22px",
    lineHeight: 28 / 22,
    fontWeight: 600,
  },
  h3: { ...base.h3, fontSize: "17px", lineHeight: 21 / 17, fontWeight: 600 },
  h4: {
    ...base.h4,
    fontFamily: "Montserrat",
    fontSize: "19px",
    lineHeight: 25 / 19,
    fontWeight: 600,
  },
  h5: { ...base.h5, fontSize: "15px", lineHeight: 19 / 15, fontWeight: 600 },
  h6: { ...base.h6, fontSize: "14px", lineHeight: 18 / 14, fontWeight: 600 },
  subtitle1: { ...base.subtitle1, fontSize: "14px", lineHeight: 20 / 14, fontWeight: 500 },
  subtitle2: { ...base.subtitle2, fontSize: "12px", lineHeight: 18 / 12, fontWeight: 500 },
  body1: { ...base.body1, fontSize: "14px", lineHeight: "normal" },
  body2: { ...base.body2, fontSize: "16px", lineHeight: "normal" },
  caption: { ...base.caption, fontSize: "11px", lineHeight: 15 / 11 },
  overline: {
    ...base.overline,
    fontSize: "10px",
    fontWeight: 600,
    textTransform: "uppercase",
    lineHeight: 16 / 10,
    letterSpacing: "0.5px",
  },
});

const MaiteThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const parent = useTheme();
  const theme = useMemo(() => {
    const overrides = createTheme(parent, { typography: buildMaiteTypography(parent.typography) });
    return responsiveFontSizes(overrides);
  }, [parent]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default MaiteThemeProvider;
